import { ActivatedRoute } from "@angular/router";

export function getFiltersFromRoute(
  route: ActivatedRoute
): Record<string, any> {
  const queryParams = route.snapshot.queryParams;
  return {
    ...queryParams,
    offset: queryParams.offset != null ? Number(queryParams.offset) : undefined
  };
}
